"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mountHeader = exports.InlineAcceptHeader = exports.AcceptScreen = void 0;
var react_1 = __importDefault(require("react"));
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var c = (0, BemBuilder_1.default)("inline-header");
var AcceptScreen;
(function (AcceptScreen) {
    AcceptScreen["SingleAccept"] = "singleAccept";
    AcceptScreen["GroupAccept"] = "groupAccept";
    AcceptScreen["Accepted"] = "accepted";
})(AcceptScreen = exports.AcceptScreen || (exports.AcceptScreen = {}));
var AcceptParticle = function (_a) {
    var x = _a.x, y = _a.y, opacity = _a.opacity, size = _a.size, delay = _a.delay, sparkle = _a.sparkle;
    if (sparkle) {
        return (react_1.default.createElement("svg", { className: (0, classnames_1.default)(c("sparkle")), width: size, height: size, fill: "none", viewBox: "0 0 41 41", style: { left: x, top: y, animationDelay: "".concat(delay, "s") } },
            react_1.default.createElement("path", { fill: "#00857B", fillOpacity: opacity, d: "M20.5 0s1.098 10.581 5.508 14.992C30.418 19.402 41 20.5 41 20.5s-10.581 1.098-14.992 5.508C21.598 30.418 20.5 41 20.5 41s-1.098-10.581-5.508-14.992C10.582 21.598 0 20.5 0 20.5s10.581-1.098 14.992-5.508C19.402 10.582 20.5 0 20.5 0z" })));
    }
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(c("particle")), style: { left: x, top: y, animationDelay: "".concat(delay, "s"), width: size, height: size } }));
};
var InlineAcceptHeader = (function (_super) {
    __extends(InlineAcceptHeader, _super);
    function InlineAcceptHeader(props) {
        return _super.call(this, props) || this;
    }
    InlineAcceptHeader.prototype.renderIcon = function () {
        var screen = this.props.screen;
        switch (screen) {
            case AcceptScreen.GroupAccept:
                return react_1.default.createElement(icons_1.Team, { size: icons_1.IconSize.Large });
            case AcceptScreen.Accepted:
                return (react_1.default.createElement("div", { className: (0, classnames_1.default)(c("icon-success")) },
                    react_1.default.createElement("div", { className: (0, classnames_1.default)(c("icon-background")) }),
                    react_1.default.createElement(AcceptParticle, { x: -28, y: 24, delay: 0, size: 5 }),
                    react_1.default.createElement(AcceptParticle, { x: -4, y: 0, delay: 0, size: 1.8 }),
                    react_1.default.createElement(AcceptParticle, { x: 50, y: -26, delay: 0, size: 2.8 }),
                    react_1.default.createElement(AcceptParticle, { sparkle: true, x: -30, y: -16, opacity: 0.6, size: 26, delay: 0.2 }),
                    react_1.default.createElement(AcceptParticle, { sparkle: true, x: 70, y: -30, opacity: 1, size: 41, delay: 0.8 }),
                    react_1.default.createElement(AcceptParticle, { sparkle: true, x: 86, y: 10, opacity: 0.2, size: 30, delay: 0.6 }),
                    react_1.default.createElement(AcceptParticle, { sparkle: true, x: -40, y: -20, opacity: 0.8, size: 38, delay: 2 }),
                    react_1.default.createElement(AcceptParticle, { sparkle: true, x: 80, y: 10, opacity: 1, size: 22, delay: 2.5 }),
                    react_1.default.createElement(AcceptParticle, { sparkle: true, x: 24, y: -30, opacity: 0.6, size: 26, delay: 1.5 }),
                    react_1.default.createElement(icons_1.Tick, { className: (0, classnames_1.default)(c("icon-success-tick")), size: icons_1.IconSize.Large })));
        }
        return react_1.default.createElement(icons_1.Tick, { size: icons_1.IconSize.Large });
    };
    InlineAcceptHeader.prototype.render = function () {
        var _a;
        var _b = this.props, onBack = _b.onBack, onClose = _b.onClose, screen = _b.screen, telemetry = _b.telemetry;
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)(c()) },
            react_1.default.createElement("div", { className: (0, classnames_1.default)(c("group")) },
                !!onBack && (react_1.default.createElement(kaleidoscope_1.IconButton, { className: c("back-button"), icon: react_1.default.createElement(icons_1.ArrowLeft, null), onClick: onBack, "aria-label": "Back" })),
                react_1.default.createElement("div", { className: (0, classnames_1.default)(c("icon"), (_a = {}, _a[c("icon", "with-static-icon")] = screen !== AcceptScreen.Accepted, _a)) }, this.renderIcon()),
                !!onClose && (react_1.default.createElement(kaleidoscope_1.IconButton, { className: c("close-button"), icon: react_1.default.createElement(icons_1.Close, null), onClick: function (event) {
                        event.preventDefault();
                        telemetry.track("Accept Form Dismissed");
                        onClose();
                    }, "aria-label": "Close Accept" })))));
    };
    return InlineAcceptHeader;
}(react_1.default.Component));
exports.InlineAcceptHeader = InlineAcceptHeader;
var mountHeader = function (mountReactComponent, props) {
    return mountReactComponent(react_1.default.createElement(InlineAcceptHeader, __assign({}, props)));
};
exports.mountHeader = mountHeader;
